import React from 'react';
import { WORKFLOWS } from '../data/workflows';

export default function WorkflowBar({ module, currentStep, lang }) {
  const steps = WORKFLOWS[module];
  if (!steps || steps.length === 0) return null;

  return (
    <div className="workflow-bar">
      {steps.map((step, idx) => {
        let status = 'future';
        if (step.id < currentStep) status = 'completed';
        if (step.id === currentStep) status = 'current';

        return (
          <React.Fragment key={step.id}>
            {idx > 0 && <span className="workflow-arrow">→</span>}
            <div className={`workflow-step ${status}`}>
              <span>{step.id}</span>
              <span>{step[lang]}</span>
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
}
